var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"cont"},[_c('div',{staticClass:"btn",on:{"click":_vm.down}},[_c('img',{attrs:{"src":require("./assets/pic_btn.png"),"alt":""}})])]),(_vm.isWeixin)?_c('div',{staticClass:"wechatCover"},[_c('img',{attrs:{"src":require("./assets/safari.png"),"alt":""}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }